import React from "react";
import {
  Box,
  FormControl,
  TextField,
  Checkbox,
  styled
} from "@mui/material";
import FormControlLabel from '@mui/material/FormControlLabel';
import ModalTwoButtons from '../../../components/Modal/ModalTwoButtons';
import STFacility from "../../../api/StationaryTesting/STFacility";

const StyledBox = styled(Box)(() => ({
  display: 'flex',
  marginBottom: "20px",
  gap: "20px",
  justifyContent: "normal!important"
}));

const StyledTextField = styled(TextField)(() => ({
  width: "35rem"
}));

const StyledFormControl = styled(FormControl)(() => ({
  display: 'flex',
  width: "50rem"
}));

const StyledDiv = styled('div')({
  display: 'flex',
  justifyContent: "space-between"
});

const STFacilityForm = ({ infoData, setInfoData, invalidField, handleChangeSTFacilityFilter, canEdit }) => {

  const [modalTwoButtonsOpen, setModalTwoButtonsOpen] = React.useState(false);

  function findFacility() {
    handleChangeSTFacilityFilter(infoData.stationaryTestFacilityName);
    closeModalTwoButtonsOpen();
  }

  function closeModalTwoButtonsOpen() {
    setModalTwoButtonsOpen(false);
  }

  function checkExistingFacility(facility) {

    if (facility) {
      STFacility.get(facility).then((facilityExists) => {
        if ((facilityExists !== undefined && facilityExists !== null))
          setModalTwoButtonsOpen(true)
      });
    }
  }

  return (

    <div>
      <StyledDiv>
        <div>
          <StyledBox sx={{ flexDirection: 'column' }}>
            <StyledFormControl sx={{ m: 1 }} variant='outlined'>

              <StyledBox sx={{ justifyContent: "space-between" }}>
                <StyledTextField
                  onChange={e => {
                    setInfoData(() => ({
                      ...infoData,
                      stationaryTestFacilityName: e.target.value
                    }))
                  }}
                  onBlur={e => {
                    checkExistingFacility(e.target.value)
                  }}
                  value={infoData.stationaryTestFacilityName}
                  id="facility-name"
                  label="Facility Name"
                  variant="outlined" size="small" margin="none"
                  error={invalidField.facilityName.length === 0 ? false : true}
                  disabled={infoData.id || !canEdit ? true : false}
                  helperText={invalidField.facilityName}
                  inputProps={{ maxLength: 50 }}
                />

                <FormControlLabel
                  label="Active"
                  onChange={e => setInfoData(() => ({
                    ...infoData,
                    isActive: e.target.checked
                  }))}
                  checked={infoData.isActive}
                  disabled={!canEdit}
                  control={<Checkbox />}
                />

                <FormControlLabel
                  label="External"
                  onChange={e => setInfoData(() => ({
                    ...infoData,
                    isExternal: e.target.checked
                  }))}
                  checked={infoData.isExternal}
                  disabled={!canEdit}
                  control={<Checkbox />}
                />
              </StyledBox>

              <StyledBox sx={{ justifyContent: "space-between" }}>
                <StyledTextField
                  onChange={e => setInfoData(() => ({
                    ...infoData,
                    externalCoordinatorEmail: e.target.value
                  }))}
                  id="facility-description"
                  label="External Coordinator Email"
                  variant="outlined" size="small" margin="none"
                  value={infoData.externalCoordinatorEmail}
                  inputProps={{ maxLength: 200 }}
                  disabled={!canEdit}
                />

              </StyledBox>

            </StyledFormControl>
          </StyledBox>

        </div>

      </StyledDiv>

      <ModalTwoButtons title={'Warning'} button1Text={'No'} button1Action={closeModalTwoButtonsOpen} button2Text={'Yes'} button2Action={findFacility} open={modalTwoButtonsOpen} setOpen={setModalTwoButtonsOpen}>
        <label>
          This Facility already exist, would you like to use it?
        </label>
      </ModalTwoButtons>

    </div>

  );
};

export default STFacilityForm;
